import React from "react";
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';

import { setLessonIsView, fetchLesson, removeCurrentLessons } from "../../../Admin/Lessons/actions";
import { clearLessonQuestions } from "../../actions";
import { useLessonItem } from './useLessonItem';
import LessonItemContent from './LessonItemContent';
import CopyLessonModal from './CopyLessonModal';
import ShareLessonModal from './ShareLessonModal';
import SendMissionForm from "../../Forms/SendMissionForm";

const LessonItem = (props) => {
    const lessonItemState = useLessonItem(props);
    const { lesson, user, IsAdmin, classRooms } = props;

    if (!lesson) return null;

    const isTeacherOrAssistant = user && user.user && user.user.UserType && (user.user.UserType.Id === 3 || user.user.UserType.Id === 4);

    return (
        <>
            {isTeacherOrAssistant && (
                <>
                    <ShareLessonModal props={props} lessonItemState={lessonItemState} />
                    {lessonItemState.showSendMission && (
                        <SendMissionForm
                            {...props}
                            handleClose={lessonItemState.handleClose}
                            lesson={lesson}
                            user={user}
                            classRooms={classRooms}
                            SelectedQuestions={lessonItemState.SelectedQuestions}
                            setSelect={lessonItemState.setSelect}
                        />
                    )}
                </>
            )}
            {IsAdmin && <CopyLessonModal props={props} lessonItemState={lessonItemState} />}
            <LessonItemContent props={props} lessonItemState={lessonItemState} />
        </>
    );
};

const mapStateToProps = state => {
    return {
        lessons: state.lessons,
        lessonQuestions: state.lessonQuestions,
        studentInClassRooms: state.studentInClassRooms
    };
};

export default connect(mapStateToProps, {
    fetchLesson,
    setLessonIsView,
    removeCurrentLessons,
    clearLessonQuestions
})(
    withTranslation('common')(
        reduxForm({
            form: 'LessonItemForm'
        })(LessonItem)
    )
);
